module.exports = __webpack_public_path__ + "static/media/cta-bg.58fb091e.jpg";